import {dashboardChartColors} from '../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../common/BarchartColumn';

export const prop = 'status';

export const config = (labels) =>
	barchartColumnConfig({
		id: 'ccpStatus',
		label: labels.status,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.acceptedByEy,
				data: [item.cRAccepted],
				color: dashboardChartColors.brand[2]
			},
			{
				name: utilLabels.receivedByEy,
				data: [item.cRReceived],
				color: dashboardChartColors.brand[1]
			},
			{
				name: utilLabels.outstandingByEy,
				data: [item.cRTotal - item.cRNotSent - item.cRReceived - item.cRAccepted],
				color: dashboardChartColors.brand[0]
			}
		]
	});
